import Vue from 'vue';
import Component from 'vue-class-component';
import { IReference } from '@/model/reference';
import authStore from '@/store/auth/auth-store';
import convoStore from '@/store/convo/convo-store';
import References from '@/components/shared/References.vue';

@Component({
  name: 'convoReferences',
  props: ['convo', 'isEditable'],
  components: { 'references' : References }
})
export default class ConvoReferences extends Vue {

  protected addConvoReference (): void {
    convoStore.dispatchAddConvoReference(this.$props['convo'])
  }

  protected removeConvoReference (reference: IReference): void {
    convoStore.dispatchRemoveConvoReference({ convo: this.$props['convo'], reference: reference })
  }

}
